<template>
  <b-container fluid class="mt-2 px-1 px-sm-3 pb-3 equipment-list-page">
    <b-row>
      <b-col cols="">
        <b-row>
          <b-col cols="">
            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
              <h2 class="text-left mb-0">{{ $t('tasksPage.title') }}</h2>
              <div class="d-flex d-sm-none justify-content-between justify-content-sm-center flex-wrap">
                <b-button @click="allowAddTask = true"
                  class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                  variant="primary">
                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                  <p class="mb-0 ml-2 text-white">{{ $t('tasksPage.addTask') }}</p>
                </b-button>
                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2 load-dropdown-3"
                  v-if="selectedRows.length">
                  <template slot="button-content">
                    <b-icon class="dots" icon="three-dots"></b-icon>
                  </template>
                  <b-dropdown-item-button @click="$bvModal.show('modal-bulk-assign-update')" class="mb-2">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.assignTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="$bvModal.show('modal-bulk-due-date-update')" class="mb-2">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.dueDateTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="showTaskMultipleUpdatePopup = true" class="mb-2">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.completeTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="setBulkDelete()">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.deleteTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
              <div class="d-none d-sm-flex justify-content-between justify-content-sm-center flex-wrap">
                <b-button @click="allowAddTask = true"
                  class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                  variant="primary">
                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                  <p class="mb-0 ml-2 text-white">{{ $t('tasksPage.addTask') }}</p>
                </b-button>
                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2 load-dropdown-3"
                  v-if="selectedRows.length">
                  <template slot="button-content">
                    <b-icon class="dots" icon="three-dots"></b-icon>
                  </template>
                  <b-dropdown-item-button @click="$bvModal.show('modal-bulk-assign-update')" class="mb-2">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.assignTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="$bvModal.show('modal-bulk-due-date-update')" class="mb-2">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.dueDateTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="showTaskMultipleUpdatePopup = true" class="mb-2">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.completeTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="setBulkDelete()">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('tasksPage.deleteTasks', { count: selectedRows.length }) }}</p>
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="data-table team-data-table table-custom-border">
              <div class="bg-white rounded">
                <div v-if="!isTableMounted" class="d-flex align-items-center px-3 py-3">
                  <b-skeleton v-for="n in 2" :key="`task-tab-skeleton-${n}`" width="80px" height="26px"
                    class="mr-3 mb-0"></b-skeleton>
                </div>
                <v-tabs v-else class="team-tabs mb-0" show-arrows>
                  <v-tab @click="setTaskType('Open')">{{ $t('tasksPage.tabOpen') }} <span class="f-12 ml-1"> ({{
                    openCount ?
                    openCount : 0 }})</span></v-tab>
                  <v-tab @click="setTaskType('Completed')">{{ $t('tasksPage.tabCompleted') }} <span class="f-12 ml-1">({{
                    completedCount ?
                    completedCount : 0 }})</span></v-tab>
                </v-tabs>
              </div>
              <div class="bg-white pt-3 pt-sm-4 rounded" v-if="!isTableMounted">
                <div class="table_row">
                  <div class="px-3 px-sm-4 pb-4" style="height: calc(100vh - 230px); overflow: hidden;">
                    <b-skeleton-table :rows="17" :columns="7"
                      :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                  </div>
                </div>
              </div>
              <div class="bg-white pt-3 pt-sm-4 rounded" v-else>
                <div class="table_row">
                  <div class="equipment-border filter-box">
                    <div class="d-flex mb-4 gap-3 flex-wrap px-3 px-sm-4">
                      <b-form-group class="text-left label font-weight-normal search-field mb-0 mr-0">
                        <b-input-group class="username-input-field">
                          <b-form-input type="text" :placeholder="$t('tasksPage.search')" v-model="filterFields.search" class="unit f-12"
                            @keyup.enter="getTaskData()"></b-form-input>
                          <b-input-group-append>
                            <b-button variant="primary" @click="getTaskData()">
                              <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group class="text-left select_arrow label mb-0 report-fields">
                        <b-form-select class="input f-12" :options="typeFilterOptions" v-model="filterFields.type" @change="setType"></b-form-select>
                      </b-form-group>
                      <div class="ml-auto d-none d-sm-flex align-items-center flex-wrap">
                        <div class="position-relative">
                          <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                            {{ activeFiltersCount }}
                          </div>
                          <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                            <div class="d-flex align-items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-sliders-horizontal w-4 h-4"
                                data-id="element-964">
                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                <line x1="16" x2="16" y1="18" y2="22"></line>
                              </svg>
                              <p class="mb-0 ml-2">{{ $t('tasksPage.filters') }}</p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <b-table ref="tableRef" class="mt-2" responsive :fields="translatedFields" :items="items" hover
                    :sticky-header="'calc(100vh - 330px)'" :current-page="currentPage" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" :no-local-sorting="true" :busy.sync="isBusy" :show-empty="emptyTable"
                    selectable select-mode="multi" no-select-on-click @row-selected="onRowSelected">
                    <template #head(selected)="">
                      <b-form-checkbox class="pl-0 w-fit-content" @change="selectRows($event)" v-model="allRowsSelected">
                      </b-form-checkbox>
                    </template>
                    <template #cell(due_date)="data">
                      <span :style="data.item.dueDateColor">{{ moment(data.item.due_date).format("ll") }}</span>
                    </template>
                    <template #cell(selected)="data">
                      <b-form-checkbox class="pl-0 w-fit-content" @change="checked(data.index, data.rowSelected)"
                        v-model="data.rowSelected">
                      </b-form-checkbox>
                    </template>
                    <template #cell(title)="data">
                      <v-app v-if="data.value && data.value !== 'null'">
                        <v-tooltip top>
                          <template #activator="{ on, attrs }">
                            <span class="w-fit-content item-description text-left" v-on="on" v-bind="attrs">{{
                              data.value
                            }}</span>
                          </template>{{ formatTooltipText(data.value) }}
                        </v-tooltip>
                      </v-app>
                      <p v-else>-</p>
                    </template>
                    <!-- The description is rich text, so the markup is stripped for
                         the cell and the tooltip. -->
                    <template #cell(description)="data">
                      <v-app v-if="plainText(data.value)">
                        <v-tooltip top>
                          <template #activator="{ on, attrs }">
                            <span class="w-fit-content item-description text-left" v-on="on" v-bind="attrs">{{
                              plainText(data.value)
                            }}</span>
                          </template><span>{{ formatTooltipText(plainText(data.value)) }}</span>
                        </v-tooltip>
                      </v-app>
                      <p v-else>-</p>
                    </template>
                    <template #cell(assigned_to)="data">
                      <span>{{ data.item.assigned_to ? data.item.assigned_to.name : '-' }}</span>
                    </template>
                    <template #cell(action)="data">
                      <div>
                        <svg @click="showTaskUpdatePopupModal(data.item.id)" v-if="data.item.status === 'Open'"
                          class="mr-4 cursor-pointer" width="15" height="18" viewBox="0 0 15 18" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M14.511 4.13098L7.70889 0.0843223C7.51986 -0.0281074 7.28441 -0.0281074 7.09538 0.0843223L0.293238 4.13098C0.111445 4.23916 0 4.43512 0 4.64666V6.95667C0 11.8221 2.81109 16.2659 7.18548 17.9595C7.32474 18.0135 7.47935 18.0135 7.61875 17.9595C11.9825 16.2701 14.8042 11.8359 14.8042 6.95667V4.64666C14.8042 4.43509 14.6928 4.23916 14.511 4.13098ZM10.3664 7.65174L6.6059 11.4123C6.37158 11.6466 5.99168 11.6466 5.75737 11.4123L4.4376 10.0925C4.20328 9.85826 4.20328 9.47832 4.4376 9.24401C4.67192 9.00973 5.05185 9.00973 5.28613 9.24401L6.1816 10.1395L9.51786 6.80321C9.75214 6.56893 10.1321 6.56893 10.3664 6.80321C10.6007 7.03756 10.6007 7.41746 10.3664 7.65174Z"
                            fill="#2D69F6" />
                        </svg>

                        <svg @click="setTaskData(data.item)" class="mr-4 cursor-pointer" width="18" height="18"
                          viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                            fill="#2CCE89" />
                        </svg>
                        <svg v-if="checkDeleteStatus(data.item)" @click="showTaskDeletePopupModal(data.item.id)"
                          class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                    </template>
                  </b-table>
                  <div class="entries-pagination px-0 px-sm-2">
                    <div class="d-flex align-items-center flex-wrap">
                      <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                      </div>
                      <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                      <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                          aria-controls="my-table"></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <DeleteModal v-if="showTaskDeletePopup" @confirm="deleteTask($event)" />
    <DeleteModal :updateMessage="true" :removeMessage="''" :message="$t('tasksPage.confirmMarkCompleted')"
      v-if="showTaskUpdatePopup" @confirm="updateTask($event)" />
    <AddAndUpdateTask :taskData="taskData" :taskID="taskID" @close="allowAddTask = false; taskData = null"
      :showRecord="allowAddTask" @taskUpdated="getTaskData" />
    <DeleteModal v-if="deleteMultipleTasksModal" @confirm="deleteTaskItems($event)"
      :message="$t('tasksPage.confirmDeleteItems', { count: selectedRows.length })" />
    <DeleteModal :updateMessage="true" :removeMessage="''"
      :message="$t('tasksPage.confirmMarkMultipleCompleted', { count: selectedRows.length })" v-if="showTaskMultipleUpdatePopup"
      @confirm="updateMultipleTasks($event)" />
    <BulkAssignUpdate @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false"
      :taskIds="selectedRows.map((data) => data.id)" v-if="selectedRows.length" @updateDocs="getTaskData()" />
    <BulkDueDateUpdate @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false"
      :taskIds="selectedRows.map((data) => data.id)" v-if="selectedRows.length" @updateDocs="getTaskData()" />
    <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
      :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('tasksPage.filtersModalTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>
      <div class="body">
        <b-form-group :label="$t('tasksPage.modelLabel')" class="text-left select_arrow label mb-0">
          <b-form-select class="input f-12 mb-3" :options="modelFilterOptions" v-model="filterFields.model" @change="getTaskData()"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('tasksPage.assignedToLabel')" class="text-left select_arrow label mb-0">
          <v-select class="bg_white w-100 f-12 mb-3" v-model="filterFields.assigned_to" :options="nameOptions"
            item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchUsers"
            @input="getTaskData()">
            <span slot="no-options">
              {{ $t('tasksPage.searchUser') }}
            </span>
          </v-select>
        </b-form-group>
      </div>
      <template #modal-footer="">
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
          <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
            @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('tasksPage.reset') }}</b-button>
          <b-button class="mx-0 h-40px w-100px m-0 m-0" block @click="$bvModal.hide('modal-filter')">{{ $t('tasksPage.close') }}</b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";
import DeleteModal from "@/components/DeleteModal.vue";
import AddAndUpdateTask from "@/components/Tasks/AddAndUpdateTask.vue";
import BulkAssignUpdate from "@/components/Tasks/BulkAssignUpdate.vue";
import BulkDueDateUpdate from "@/components/Tasks/BulkDueDateUpdate.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "tasks",
  components: { DeleteModal, AddAndUpdateTask, BulkAssignUpdate, BulkDueDateUpdate, vSelect },
  data() {
    return {
      moment,
      taskType: 'Open',
      countries: [],
      selectedRows: [],
      allRowsSelected: false,
      showTaskDeletePopup: false,
      showTaskMultipleUpdatePopup: false,
      taskData: null,
      showTaskUpdatePopup: false,
      openCount: 0,
      deleteMultipleTasksModal: false,
      completedCount: 0,
      allowAddTask: false,
      rows: 1,
      emptyTable: false,
      positionText: "",
      taskID: null,
      sortBy: undefined,
      sortDesc: undefined,
      isBusy: false,
      nameOptions: [],
      isTableMounted: false,
      perPage: 25,
      currentPage: 1,
      items: [],
      filterFields: {
        search: '',
        type: '',
        model: '',
        assigned_to: ''
      },
      pageOptions: [
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "company",
      "userCompany",
      "rolePermissions",
      "user",
      "allTeamMembers"
    ]),
    translatedFields() {
      return [
        { key: "selected", label: "", sortable: false, thClass: 'font-table-weight-bold', thStyle: { minWidth: "20px", width: "20px" } },
        { key: "record", label: this.$t('tasksPage.columnRecord'), sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true },
        { key: "model", label: this.$t('tasksPage.columnModel'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "title", label: this.$t('tasksPage.columnTitle'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "description", label: this.$t('tasksPage.columnDescription'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "add_date", label: this.$t('tasksPage.columnAddDate'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "due_date", label: this.$t('tasksPage.columnDueDate'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "assigned_to", label: this.$t('tasksPage.columnAssignedTo'), sortable: true, thClass: 'font-table-weight-bold' },
        { key: "action", label: this.$t('tasksPage.columnAction'), sortable: false, thClass: 'font-table-weight-bold' },
      ];
    },
    typeFilterOptions() {
      return [
        { value: '', text: this.$t('tasksPage.selectType') },
        { value: 'created_by_me', text: this.$t('tasksPage.typeCreated') },
        { value: 'assigned_to_me', text: this.$t('tasksPage.typeAssigned') },
        { value: 'both', text: this.$t('tasksPage.typeBoth') },
      ];
    },
    modelFilterOptions() {
      return [
        { value: '', text: '' },
        { value: 'Driver', text: this.$t('tasksPage.modelDriver') },
        { value: 'Vehicle', text: this.$t('tasksPage.modelVehicle') },
        { value: 'Trailer', text: this.$t('tasksPage.modelTrailer') },
        { value: 'Company', text: this.$t('tasksPage.modelCompany') },
      ];
    },
    activeFiltersCount() {
      return Object.keys(this.filterFields).reduce((count, key) => {
        if (
          this.filterFields[key] !== '' &&
          this.filterFields[key] !== null
        ) {
          return count + 1;
        }
        return count;
      }, 0);
    },
  },
  methods: {
    ...mapActions([
      "setNotification",
      "setLoader",
      "getAllTasks",
      "deleteTaskData",
      "getAllTags",
      'updateTaskData',
      "deleteBulkTasks",
      "getAllTeamMembers",
      "updateBulkTasks"
    ]),
    // Descriptions come from a rich-text editor: drop the tags and turn the
    // entities back into characters so the cell shows readable text.
    plainText(value) {
      if (!value || value === "null") return "";
      const holder = document.createElement("div");
      holder.innerHTML = `${value}`.replace(/<\/(p|div|br|li|h[1-6])>/gi, " ");
      return (holder.textContent || "").replace(/\s+/g, " ").trim();
    },
    formatTooltipText(text) {
      const maxLineLength = window.screen.width <= 767 ? 50 : 80;
      let formattedText = "";
      let lineLength = 0;

      text.split(' ').forEach(word => {
        if (lineLength + word.length + 1 > maxLineLength) {
          formattedText += "\n";
          lineLength = 0;
        }
        formattedText += (lineLength === 0 ? "" : " ") + word;
        lineLength += word.length + 1;
      });

      return formattedText;
    },
    setType(value) {
      localStorage.setItem('taskTypeFilter', value)
      this.getTaskData()
    },
    async setBulkDelete() {
      let deletePermission = true
      this.selectedRows.map((item => {
        if (!this.checkDeleteStatus(item)) {
          deletePermission = false
        }
      }))
      if (deletePermission) this.deleteMultipleTasksModal = true;
      else {
        await this.setNotification({
          msg: this.$t('tasksPage.noDeletePermission'),
          type: "error",
          color: "red",
        });
      }
    },
    async searchUsers(searchText) {
      let options = []
      let url = `page=1&page_size=20&name=${searchText}`;
      await this.getAllTeamMembers(url);
      this.allTeamMembers.map((member) => {
        options.push({
          id: `${member.id}`,
          label: member.user.first_name + ' ' + member.user.last_name,
        });
      });
      this.nameOptions = options
      this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
    },
    checkDeleteStatus(data) {
      return data.created_by.id === this.user?.team_member?.id
    },
    async deleteTaskItems(status) {
      if (status) {
        try {
          this.setLoader(true)
          await this.deleteBulkTasks({ task_ids: this.selectedRows.map(item => item.id) })
          this.setLoader(false)
          await this.setNotification({
            msg: this.$t('tasksPage.tasksDeleted'),
            type: "success",
            color: "green",
          })
          await this.getTaskData();
          this.$refs.tableRef.clearSelected()
          this.allRowsSelected = false
          this.deleteMultipleTasksModal = false;
        } catch (e) {
          this.deleteMultipleTasksModal = false;
          this.setLoader(false)
          await this.setNotification({
            msg: e,
            type: "error",
            color: "red",
          });
        }
      }
      else {
        this.deleteMultipleTasksModal = false
        this.$refs.tableRef.clearSelected();
        this.allRowsSelected = false
        this.selectedRows = []
      }
    },
    async updateMultipleTasks(status) {
      if (status) {
        try {
          this.setLoader(true)
          await this.updateBulkTasks(
            {
              "task_ids": this.selectedRows.map(item => item.id),
              "status": "Completed"
            }
          )
          this.setLoader(false)
          await this.setNotification({
            msg: this.$t('tasksPage.tasksUpdated'),
            type: "success",
            color: "green",
          })
          await this.getTaskData();
          this.$refs.tableRef.clearSelected()
          this.allRowsSelected = false
          this.showTaskMultipleUpdatePopup = false;
        } catch (e) {
          this.showTaskMultipleUpdatePopup = false;
          this.setLoader(false)
          await this.setNotification({
            msg: e,
            type: "error",
            color: "red",
          });
        }
      }
      else {
        this.showTaskMultipleUpdatePopup = false
        this.$refs.tableRef.clearSelected();
        this.allRowsSelected = false
        this.selectedRows = []
      }
    },
    selectRows(checked) {
      if (checked) {
        this.$refs.tableRef.selectAllRows()
      }
      else {
        this.$refs.tableRef.clearSelected()
        this.allRowsSelected = false
      }
    },
    checked(index, checked) {
      let tableRef = this.$refs.tableRef
      if (checked === true) tableRef.selectRow(index)
      else tableRef.unselectRow(index)
    },
    onRowSelected(items) {
      this.selectedRows = items
    },
    async updateTask(status) {
      if (status) {
        try {
          await this.updateTaskData({ taskId: this.taskID, payload: { status: 'Completed' } })
          await this.setNotification({
            msg: this.$t('tasksPage.taskUpdated'),
            type: "success",
            color: "green",
          });
          this.taskID = null
          this.showTaskUpdatePopup = false;
          await this.getTaskData()
        }
        catch (error) {
          this.taskID = null
          this.showTaskUpdatePopup = false;
          if (typeof error === "object" && error.error) {
            await this.setNotification({
              msg: error.error,
              type: "error",
              color: "red",
            });
          }
        }
      }
      else this.showTaskUpdatePopup = false
    },
    async deleteTask(status) {
      if (status) {
        try {
          await this.deleteTaskData(`${this.taskID}/?company_id=${this.userCompany}`)
          await this.setNotification({
            msg: this.$t('tasksPage.taskDeleted'),
            type: "success",
            color: "green",
          });
          this.taskID = null
          this.showTaskDeletePopup = false;
          await this.getTaskData()
        }
        catch (error) {
          this.taskID = null
          this.showTaskDeletePopup = false;
          if (typeof error === "object" && error.error) {
            await this.setNotification({
              msg: error.error,
              type: "error",
              color: "red",
            });
          }
        }
      }
      else this.showTaskDeletePopup = false
    },
    showTaskDeletePopupModal(id) {
      this.showTaskDeletePopup = true;
      this.taskID = id;
    },
    showTaskUpdatePopupModal(id) {
      this.showTaskUpdatePopup = true;
      this.taskID = id;
    },
    checkNullValues(payload) {
      let nullKeys = [];
      for (let [key, value] of Object.entries(payload)) {
        if (!value) {
          nullKeys.push(key);
        }
      }
      return nullKeys;
    },

    async setTaskType(type = "") {
      this.taskType = type
      this.currentPage = 1
      this.resetFilterFields()
    },
    async getTaskNewData(id = null) {
      this.allowAddTask = false
      await this.getTaskData()
      if (id) {
        this.taskID = id
      }
    },
    async resetFilterFields() {
      this.selectedRows = []
      this.allRowsSelected = false
      this.$refs.tableRef.clearSelected()
      this.filterFields = {
        search: '',
        type: '',
        model: '',
        assigned_to: ''
      }
      await this.getTaskData();
    },
    setTaskData(data) {
      this.taskData = data
      this.allowAddTask = true
    },
    async updateFields(updatedFields) {
      this.fields = updatedFields
      this.filterFields = {
        search: '',
        type: '',
        model: '',
        assigned_to: ''
      }
      try {
        await this.getTaskData();
      }
      catch (e) {
        console.log(e)
      }
    },
    async getTaskData() {
      try {
        this.isBusy = true
        let url = ""
        this.items = []
        if (localStorage.getItem('taskTypeFilter')) this.filterFields.type = localStorage.getItem('taskTypeFilter')
        Object.keys(this.filterFields).map((key) => {
          if (this.filterFields[key]) {
            if (key !== 'search') url += `${key}=${this.filterFields[key]}&`
            else {
              let searchList = "record_name,description"
              url += `${key}=${this.filterFields[key]}&search_list=${searchList}&`
            }
          }
        })
        if (this.sortBy) {
          url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
        }
        else {
          url += `sort_field=due_date&sort_order=asc&`
        }
        url += `page=${this.currentPage}&page_size=${this.perPage}&tab=${this.taskType}`
        const data = await this.getAllTasks(url);
        this.openCount = data.counts.Open >= 0 ? data.counts.Open : 0
        this.completedCount = data.counts.Completed >= 0 ? data.counts.Completed : 0
        if (data.total_entries_count) {

          data.data.map((item) => {
            let dueDateColor;
            if (item.due_date) {
              const currentDate = new Date();
              const dueDate = new Date(item.due_date);
              let daysDiff = parseInt(
                (dueDate - currentDate) / (1000 * 60 * 60 * 24),
                10
              );
              if (daysDiff <= 0) {
                dueDateColor = "color:red";
              } else if (daysDiff <= 3 && daysDiff >= 1) {
                dueDateColor = "color:#FFC800";
              } else {
                dueDateColor = "color:black";
              }
            }
            this.items.push({
              id: item.id,
              record: item.record_name ? item.record_name : '-',
              add_date: item.add_date ? moment(item.add_date).format("ll") : '-',
              assigned_to: item.assigned_to,
              status: item.status,
              due_date: item.due_date,
              title: item.title,
              description: item.description,
              model: item.model ? item.model : '-',
              dueDateColor: dueDateColor,
              created_by: item.created_by
            });
          })
          this.rows = data.total_entries_count
          const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
          const end = this.perPage * (this.currentPage - 1) + data.queryset_count
          this.positionText = this.$t('tasksPage.positionText', { start, end, total: data.total_entries_count })
        }
        else {
          this.rows = 0
          this.positionText = this.$t('tasksPage.emptyPosition')
        }
        if (this.items.length === 0) this.emptyTable = true
        else this.emptyTable = false
        this.isBusy = false
        this.isTableMounted = true
      }
      catch (e) {
        this.isBusy = false
        this.isTableMounted = true
        console.log(e)
      }
    },
  },
  watch: {
    perPage: {
      async handler() {
        await this.getTaskData();
      },
      immediate: true,
    },
    currentPage: {
      async handler() {
        await this.getTaskData();
      },
    },
    sortBy: {
      async handler() {
        await this.getTaskData();
      },
    },
    sortDesc: {
      async handler() {
        await this.getTaskData();
      },
    },
    filterFields: {
      handler() {
        this.currentPage = 1
      },
      deep: true
    },
  },
  async mounted() {

  },
};
</script>
